import React from 'react';
export function SectionDivider() {
  return <div className="flex items-center justify-center py-3 md:py-5" data-id="element-88">
      <div className="h-px w-16 bg-[#d4a853]/30" data-id="element-89" />
      <div className="mx-4 w-2 h-2 rotate-45 bg-[#d4a853]/50" data-id="element-90" />
      <div className="h-px w-16 bg-[#d4a853]/30" data-id="element-91" />
    </div>;
}